module.exports = __webpack_public_path__ + "static/media/self-established-yes.4d6d50c8.svg";